import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "folder-closed",
  "use": "folder-closed-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"folder-closed\">\n    <g transform=\"translate(0 -2)\">\n        <path d=\"M0,0H16V16H0Z\" transform=\"translate(0 2)\" fill=\"none\" />\n        <path d=\"M10.331,4.556H17.2a.789.789,0,0,1,.8.778V16.222a.789.789,0,0,1-.8.778H2.8a.789.789,0,0,1-.8-.778V3.778A.789.789,0,0,1,2.8,3H8.731Z\" transform=\"translate(-2 0)\" fill=\"#151515\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol